import {h, Component} from 'preact';
import Cart from '@components/cart';
import debounce from 'lodash.debounce';
import {compose, graphql} from 'react-apollo';
import {GetCart, AddLineItems} from '@services/CartService/query.graphql';
import {GetPastPurchases} from '@services/OrdersService/query.graphql';
import {calculateSubtotal} from '@modules/cart/Cart';
import CartService from '@services/CartService';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import Provider from 'preact-context-provider';
import LineItem from '@components/cart/LineItem';
import shallowCompare from 'preact-shallow-compare';

// todo -> this component should handle events to toggle cart panel open/close
// todo -> create Responsive Render Prop component to handle conditional rendering of components like this
class MiniCart extends Component {

    state = {
        isUpdating: false
    };

    constructor ( props ) {
        super( props );

        this._onInputUpdateDebounced = debounce( this.onInputChange, 800 );
    }

    shouldComponentUpdate ( nextProps, nextState ) {
        return shallowCompare( this, nextProps, nextState );
    }

    onCartChange = ( {isUpdating} ) => {
        console.log( '[onCartChange] isUpdating', isUpdating );
        this.setState( {isUpdating} );
    };

    onInputBlur = ( {quantity, product} ) => {
        console.log( 'onInputBlur.quantity', quantity );
        if ( quantity <= 0 ) {
            this.onDeleteItem( {product} );
        }
    };

    onInputChange = ( {product, quantity} ) => {
        if ( quantity <= 0 ) {
            return this.onDeleteItem( {product} );
        }

        console.log( '[updateLineItem]', {product, quantity} );
        this.onCartChange( {isUpdating: true} );
        CartService.updateLineItems( {product, quantity} )
            .finally( () => this.onCartChange( {isUpdating: false} ) );
    };

    onDeleteItem = ( {product} ) => {
        console.log( '[deleteLineItem]', {product} );
        this.onCartChange( {isUpdating: true} );
        CartService.deleteLineItems( {product} )
            .finally( () => this.onCartChange( {isUpdating: false} ) );
    };

    render ( {isLogged} ) {
        return (
            <Provider
                onCartChange={this.onCartChange}
                isUpdating={this.state.isUpdating}
                user={{isLogged}}>
                <div data-testid="minicart-cart"
                     className="cart-panel-inner flex flex-col w-full h-full bg-grey-lightest">
                    <MiniCartQuery isUserLogged={isLogged}
                                   onLineInputBlur={this.onInputBlur}
                                   onLineInputChange={this._onInputUpdateDebounced}
                                   onLineItemDelete={this.onDeleteItem}
                    />
                </div>
            </Provider>
        );
    }
}

const Query = ( props ) => {
    const {
        cartData,
        suggestedProductsData,
        onLineInputBlur,
        onLineInputChange,
        onLineItemDelete
    } = props;

    if ( cartData.loading ) {
        return <Cart.Loading/>;
    }
    if ( cartData.error ) {
        return <Cart.Error/>;
    }

    const {cart} = cartData;
    let suggestedProducts;

    if ( suggestedProductsData ) {
        suggestedProducts = suggestedProductsData.suggestedProducts;
    }

    const hasContent = (cart && cart.lineItems && cart.lineItems.length);

    return hasContent
        ? <Cart.Content
            data-testid="minicart-cart-content"
            cart={cart}
            suggestedProducts={suggestedProducts}
            render={( {groupedLines} ) => (
                <div>
                    <ul className="lineItemCollection">
                        {groupedLines.lineItems.map( item =>
                            <LineItem.Editable
                                key={item.id}
                                {...item}
                                onLineInputBlur={onLineInputBlur}
                                onLineInputChange={onLineInputChange}
                                onLineItemDelete={onLineItemDelete}/>
                        )}
                    </ul>
                    {
                        !isEmptyOrNil( groupedLines.promotionalItems ) &&
                        <div id="cart-preview-promotional">
                            <h3 class="p-4 pb-2 text-sm bg-near-white">Also included with your order</h3>
                            <ul className="lineItemCollection">
                                {groupedLines.promotionalItems.map(
                                    item => <LineItem.NonEditable key={item.id} {...item} /> )}
                            </ul>
                        </div>
                    }
                </div>
            )}
        />

        : <Cart.Empty/>
};

const withCart = graphql( GetCart, {
    name: 'cartData',
    options: {
        fetchPolicy: 'network-only'
    }
} );
const withPastPurchases = graphql( GetPastPurchases, {
    options: {
        variables: {resultLimit: 6, filterCart: true}
    },
    skip: ( {isUserLogged} ) => !isUserLogged,
    name: 'suggestedProductsData'
} );

const MiniCartQuery = compose( withCart, withPastPurchases )( Query );
export default MiniCart;
